import PropTypes from 'prop-types';
import { styled } from '@activebrands/core-web/libs/styletron';
import ActBonusVouchers from './ActBonusVouchers';

const Hr = styled('hr', {
    borderTop: '0px',
    borderLeft: '0px',
    borderRight: '0px',
    borderBottom: '1px solid var(--color-border-checkout-act-content)',
});

const AuthenticatedActRewardsContent = ({ $style, isVouchersAvailable }) => {
    return (
        <div>
            <Hr />{' '}
            <ActBonusVouchers $style={{ marginTop: '16px', ...$style }} isVouchersAvailable={isVouchersAvailable} />
        </div>
    );
};

AuthenticatedActRewardsContent.propTypes = {
    $style: PropTypes.object,
    isVouchersAvailable: PropTypes.bool,
};

export default AuthenticatedActRewardsContent;
